import { createSlice } from '@reduxjs/toolkit';
import { IWaiveReasonResponse } from '../interfaces/IWaiveReasonResponse';

const defaultState = {
  activeTaskId: '',
  waiveReasons: [],
  orderEvidenceFailed: false,
  orderEvidenceError: '',
  orderEvidenceErrorType: '',
};

export const taskUiSlice = createSlice({
  name: 'taskUi',
  initialState: defaultState,

  reducers: {
    fetchWaiveReasonsSuccess: (state, action) => {
      state.waiveReasons = action.payload.waiveReasons.map(
        (reason: IWaiveReasonResponse) => {
          return {
            value: reason.name,
            label: reason.displayText,
          };
        },
      );
    },
    updateActiveTask: (state, action) => {
      state.activeTaskId = action.payload.activeTaskId;
    },
    clearTaskMeta: (state, _) => {
      Object.assign(state, defaultState);
    },
    onOrderEvidenceFailed: (state, action) => {
      state.orderEvidenceFailed = true;
      state.orderEvidenceError = action.payload.message;
      state.orderEvidenceErrorType = action.payload.type;
    },
  },
});

export const taskUiReducer = taskUiSlice.reducer;
export const taskUiActions = taskUiSlice.actions;
